import React from 'react';
import styled from 'styled-components';
import Component from './component';
import { usePreview } from '../provider';

const Van = styled(Component)`
  font-weight: 500;
  font-size: 1rem;
  text-decoration: line-through;
`;

const PreviewPrice = ({
  field = 'lowestPrice',
  withLink,
  appendBTWWhenIncl = true,
  appendBTWWhenExcl = true,
  priceFormat,
  returnNullOnSold = false,
  prepend,
  append,
  ...props
}) => {
  const {
    isSold,
    taxType,
    regularPriceExBtw,
    regularPrice,
    lowestPrice,
    privateLease,
  } = usePreview();

  if (isSold) {
    if (returnNullOnSold) {
      return null;
    }
    return <div {...props}><span>Verkocht</span></div>;
  }

  const hasVanVoor = field === 'lowestPrice' && regularPrice && regularPrice !== lowestPrice;
  const hasPrivateLeaseNote = field === 'privateLease.price' && privateLease && privateLease.price && privateLease.note;

  return (
    <>
      {hasVanVoor && (
        <Van
          rewriteFieldFn={priceFormat}
          field="regularPrice"
          withLink={withLink}
          append={taxType === 'BTW' && ((regularPriceExBtw && appendBTWWhenExcl) || (!regularPriceExBtw && appendBTWWhenIncl)) && <> {regularPriceExBtw ? 'excl.' : 'incl.'} BTW </>}
        />
      )}
      <Component
        css={hasVanVoor ? 'color: red' : null}
        rewriteFieldFn={priceFormat}
        field={field}
        withLink={withLink}
        prepend={`${prepend || ''}${(prepend && hasVanVoor) ? ' ' : ''}${hasVanVoor ? process.env.GATSBY_PREPEND_VAN_VOOR_VOOR : ''}`}
        append={(
          <>
            {(taxType === 'BTW' && ((regularPriceExBtw && appendBTWWhenExcl) || (!regularPriceExBtw && appendBTWWhenIncl))) && <> {regularPriceExBtw ? 'excl.' : 'incl.'} BTW </>}
            {append}
          </>
        )}
        {...props}
      />
      {hasPrivateLeaseNote && (
        <Note>
          {privateLease.note}
        </Note>
      )}
    </>
  );
};

const Note = styled.span`
  display: block;
  margin-top: 0.5rem;
  font-size: 90%;
`;

export default styled(PreviewPrice)`
  margin: 0;
`;
